import { render, staticRenderFns } from "./SubscriptionPackageWithForm.vue?vue&type=template&id=770c9f29&"
import script from "./SubscriptionPackageWithForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPackageWithForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPackageWithForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports